import React from 'react'
import AssessmentIcon from '@mui/icons-material/Assessment';
import AppBar from '@mui/material/AppBar';
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import FolderOpenIcon from '@mui/icons-material/FolderOpen'
import FolderCloseIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import EditIcon from '@mui/icons-material/Edit';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import PublishIcon from '@mui/icons-material/Publish';
import DeleteIcon from '@mui/icons-material/Delete';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import UploadPresentation from '../overlays/UploadPresentation'
import { dateParser, dynamicSort } from '../utilities/helperFunctions'
import ContextMenu from '../ui/ContextMenu'
import excelbw from '../../images/svg/excel_bw.svg'
import pptbw from '../../images/svg/ppt_bw.svg'
import downArrow from '../../images/js/downArrow'
import upArrow from '../../images/js/upArrow'
import check from '../../images/js/check'
import x from '../../images/js/x'
import { HandlePresentationFilter } from '../utilities/helperFunctions'

function PresentationProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

function TabPanel(props) {
    const {
        children, value, index, ...other
    } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <div>{children}</div>}
        </div>
    );
}

class Presentations extends React.Component {
    state = {
        xPos: null,
        yPos: null,
        rightClick: false,
        id: null,
        rename: false,
        renameField: "",
        renameTarget: null,
        value: 0,
        expanded: {},
    }

    setExpanded(id, value) {        
        let exp = this.state.expanded;
        exp[id] = value;
        this.setState({ expanded: exp })
    }

    componentDidMount() {
        let filter = HandlePresentationFilter(this.props.presentationFilter)
        this.setState({ value: filter["value"] })
        this.handleFilters(filter["label"])
    }

    handleChangeForm = (event, newValue) => {
        this.setState({ value: newValue })
        this.handleFilters(newValue === 0 ? 'myPresentations' : newValue === 1 ? "allPresentations" : "templates")
    };

    changeRename = (event) => {
        event.preventDefault()
        this.setState({ renameField: event.target.value })
    }

    downloadPres = (id) => {
        let presentationToDownload = this.props.presentationList.find(x => x.id === parseInt(id));
        let fileName = presentationToDownload.name;

        if (presentationToDownload.documentTypeID === 0) {
            fileName = fileName + ".pptx";
        } else if (presentationToDownload.documentTypeID === 1) {
            fileName = fileName + ".xlsx";
        }

        this.props.downloadPresentation(id, fileName);
    }

    contextDownloadPres = (id) => {
        let presentationToDownload = this.props.presentationList.find(x => x.id === parseInt(id));
        let fileName = presentationToDownload.name;

        if (presentationToDownload.documentTypeID === 0) {
            fileName = fileName + ".pptx";
        } else if (presentationToDownload.documentTypeID === 1) {
            fileName = fileName + ".xlsx";
        }

        this.props.downloadPresentation(id, fileName)
    }

    contextDeletePresentation = (id) => {
        this.props.showPopup("deletePresentation", id)
    }

    handleSort = (event) => {
        event.preventDefault()
        let split = this.props.presentationFilter.split('|')[1]
        let string = ""
        if (this.props.presentationFilter === `sort|${split}|${event.target.dataset.category}|asc`) {
            string = `sort|${split}|${event.target.dataset.category}|desc`
        } else {
            string = `sort|${split}|${event.target.dataset.category}|asc`
        }
        this.props.applyFilter(string, "presentations")
    }

    renderArrow = (string) => {
        if (this.props.presentationFilter.includes(string)) {
            if (this.props.presentationFilter.includes("asc")) {
                return downArrow("black", 18, null, string)
            } else {
                return upArrow("black", 18, null, string)
            }
        } else {
            return null;
        }

    }
    
    goToPresentation = (id) => {
        let documentTypeID = this.props.presentationList.find(x => x.id === parseInt(id)).documentTypeID;

        if (documentTypeID === 0) {
            window.location = `/presentations/powerpoint/${id}`;
        } else if (documentTypeID === 1) {
            window.location = `/presentations/excel/${id}`;
        }
    }

    handleEditConnection = (id) => {
        let presentationToDownload = this.props.presentationList.find(x => x.id === id);
        this.editConnection(id, presentationToDownload.documentTypeID)
    }

    editConnection = (id, docTypeId) => {
        this.props.getConnectionInfos(id, docTypeId)
        this.props.showPopup("editPresentationInfo", id)
    }

    isThisPresentationChildOfStory = (presInfo, allPres) => {
        let rtnVal = true;

        if (presInfo.parentPresentationId === null) {
            rtnVal = false;
        }
        else {
            let parent = allPres.find(p => p.id === presInfo.parentPresentationId);
            if (presInfo.parentPresentationId === presInfo.id) {
                rtnVal = false;
            } else {
                if (parent) {
                    rtnVal = parent.isStory;
                } else {
                    rtnVal = false;
                }
            }
        }

        return rtnVal;
    };

    handleFilters = (name) => {
        // event.preventDefault()
        let filterTerm = "filter|" + name
        this.props.applyFilter(filterTerm, "presentations")
    }

    handleStyle = (string) => {
        if (this.props.presentationFilter.includes(string))
            return {
                'borderBottom': '2px solid orange', 'fontWeight': 'bold'
            }
        else
            return null;

    }

    handlePresentation = (id, name) => {
        let presentationID = id;
        let documentTypeID = this.props.presentationList.find(x => x.id === parseInt(id)).documentTypeID;

        if (name !== "delete" && name !== "download" && name !== "edit") {
            this.goToPresentation(presentationID, documentTypeID);
        }
    }

    handleContextMenu = (event, id) => {
        event.preventDefault();
        if (this.state.rightClick) {
            this.setState({ xPos: null, yPos: null, id: null, rightClick: false })
        } else {
            this.setState({ xPos: event.pageX - 70, yPos: event.pageY - 70, id: id, rightClick: true })
        }
    }

    handleUploadPres = (event) => {
        event.preventDefault();
        this.props.showPopup("uploadPresentation");
    }

    handleUpdatePres = (event, id) => {
        event.preventDefault();
        this.props.showPopup("updatePresentation", id);
    }

    handleDeletePres = (id) => {
        this.props.showPopup("deletePresentation", id)
    }
    // mini progress bar is the full empty bar, filler is based on the presentation refresh progress
    handleProgressBar = (id) => {
        return (Object.keys(this.props.presentationsProgress).includes(id.toString())) ? (<div className="miniProgressBar"><div className="filler" style={{ width: `${this.props.presentationsProgress[id.toString()] * 10 + 10}%` }}></div></div>) : null
    }

    handleRename = (name, id) => {
        if (!this.state.rename || this.state.renameTarget !== id) {
            return <TableCell style={{ "cursor": "pointer" }} align="right" onClick={() => this.handlePresentation(id, '')} onContextMenu={(e) => this.handleContextMenu(e, id)} data-id={id} onMouseEnter={this.handleMouseHover} onMouseLeave={this.handleHoverEnd}>{name} {this.handleProgressBar(id)}</TableCell>
        } else if (this.state.rename && this.state.renameTarget === id) {
            return <TableCell align="right"><input type="text" data-name={name} onChange={this.changeRename} value={(this.state.renameField === "") ? name : this.state.renameField} onKeyUp={this.handleRenameSubmit} style={{ width: "95%" }} /></TableCell>
        }
    }

    handleRenameSubmit = (event) => {
        event.preventDefault()
        if (event.keyCode === 13) {
            this.props.sendRenamePresentation(this.state.renameTarget, (this.state.renameField === "") ? event.target.dataset.name : this.state.renameField)
        }
    }

    handleDocumentTypeDisplay = (documentTypeId) => {
        if (documentTypeId === 0) {
            return ".pptx"
        } else if (documentTypeId === 1) {
            return ".xlsx"
        } else {
            return null;
        }

    }

    handleDocumentTypeIconDisplay = (documentTypeId, Id) => {
        return documentTypeId === 1 ?
            <img src={excelbw} class="iconButton" data-id={Id} />
            :
            <img src={pptbw} class="iconButton" data-id={Id} />
    }

    renderPresentations = (folderId) => {
        if (this.props.presentationList.Count === 0) {
            return null
        } else {
            let list = this.props.presentationList
            // if folder specified, filter by folder, else get presentations by null folderIds
            list = list.filter(f => f.folderID == folderId);
            if (list.length == 0) {
                return null;
            } 

            // this section in the else clause is for handling filtering for different tab views
            if (this.props.presentationFilter.includes("sort|")) {
                list = this.getSortedPresentationList(list);
            } else {
                list = this.getFilteredPresentationList(list);
            }
            if (this.props.presentationTagsFilter && this.props.presentationTagsFilter.length > 0) {
                list = this.getTagFilteredPresentationList(list);
            }          

            return list.map(x =>
                <TableRow key={x.id}>
                    {this.handleRename(x.name, x.id)}
                    <TableCell align="right" onClick={() => this.handlePresentation(x.id, '')} onContextMenu={(e) => this.handleContextMenu(e, x.id)} data-id={x.id}>{x.createdBy}</TableCell>
                    <TableCell align="right" onClick={() => this.handlePresentation(x.id, '')} onContextMenu={(e) => this.handleContextMenu(e, x.id)} data-id={x.id}>
                        {dateParser(x.modifiedDate)}
                    </TableCell>
                    <TableCell align="right">
                        <IconButton onClick={() => this.handlePresentation(x.id, '')}>
                            {x.documentTypeID === 0 ? (
                                <img
                                    src={pptbw}
                                    alt="Powerpoint Document"
                                    title="Powerpoint Document"
                                    className="excelIcons"
                                    style={{ width: '17px', marginRight: '3px' }}
                                />
                            ) : (
                                    <img
                                        src={excelbw}
                                        alt="Excel Document"
                                        title="Excel Document"
                                    className="excelIcons"
                                    style={{ width: '17px', marginRight: '3px' }}
                                />
                            )}
                        </IconButton>
                        {this.isThisPresentationChildOfStory(x, list) && <IconButton onClick={() => this.handlePresentation(x.id, '')} title="This Presentation Is A Story">
                            <MenuBookIcon />
                        </IconButton>}
                        {(this.props.role !== "Viewer") && <IconButton onClick={() => this.handleEditConnection(x.id)} data-id={x.id} data-name="edit" id="editpresentation_btn" title="Edit Presentation">
                            <EditIcon />
                        </IconButton>}
                        {(this.props.role !== "Viewer") && x.isStory === true && <IconButton onClick={(e) => this.handleUpdatePres(e, x.id)} data-id={x.id} data-name="update" id="updatepresentation_btn" title="Update Parent Story Presentation">
                            <PublishIcon />
                        </IconButton>}
                        <IconButton
                            title="Download Presentation"
                            onClick={() => this.downloadPres(x.id)} data-id={x.id} data-name="download" id="downloadpresentation_btn"
                        >
                            <SaveAltIcon />
                        </IconButton>
                        <IconButton
                            title="Delete Presentation"
                            onClick={() => this.handleDeletePres(x.id)} data-id={x.id} data-name="delete" id="deletepresentation_btn"
                        >
                            <DeleteIcon />
                        </IconButton>
                    </TableCell>
                </TableRow>)
        }
    }

    presentationCount(folderId) {
        if (this.props.presentationList.Count === 0) {
            return 0
        } else {
            let list = this.props.presentationList
            // if folder specified, filter by folder, else get presentations by null folderIds
            list = list.filter(f => f.folderID == folderId);
            if (list.length == 0) {
                return 0;
            }

            list = this.getFilteredPresentationList(list);

            if (this.props.presentationTagsFilter && this.props.presentationTagsFilter.length > 0) {
                list = this.getTagFilteredPresentationList(list);
            }

            return list.length;
        }
    }

    renamePresentation = (id) => {

        this.setState({ xPos: null, yPos: null, id: null, rightClick: false })
        this.setState({ rename: true, renameTarget: parseFloat(id), xPos: null, yPos: null })
    }

    handleMessage = () => {
        if (this.state.message === false) {
            return <div className="customerMessage"><p style={{ fontStyle: 'italic', cursor: 'pointer' }} onClick={this.toggleMessage}>{(this.props.message) ? this.props.message : "leave messages for your team here"}</p></div>
        } else {
            return <div className="customerMessage"><input className="customerTextBox" type="text" onChange={this.changeMessage} value={this.state.messageField} onKeyUp={this.handleMessageSubmit} />{x("#7CB6F9", "8px", this.messageCancel, "12px")}{check("#7CB6F9", this.messageSubmit, "28px")}</ div>
        }
    }

    toggleMessage = () => {
        this.setState({ message: !this.state.message })
    }

    getFilteredPresentationList = (list) => {
        if (this.props.presentationFilter.includes("filter|")) {
            let split = this.props.presentationFilter.split("|")
            if (split[1] === "myPresentations") {
                list = list.filter(x => ((x.modifiedBy !== null) ? x.modifiedBy.toLowerCase() : x.createdBy.toLowerCase()) === this.props.email.toLowerCase()).sort(dynamicSort("modifiedDate")).reverse()
            } else if (split[1] === "templates") {
                list = list.filter(x => x.isTemplate === true).sort(dynamicSort("modifiedDate")).reverse()
            } else
                list = list.sort(dynamicSort("modifiedDate")).reverse()

        } else {
            list = list.filter(x => x.name.toLowerCase().includes(this.props.presentationFilter.toLowerCase())).sort(dynamicSort("modifiedDate")).reverse()
        }
        return list;
    }

    getSortedPresentationList = (list) => {
        let splitPresentationFilter = this.props.presentationFilter.split("|")
        let filterCategory = splitPresentationFilter[1]
        let sortCategory = splitPresentationFilter[2]
        let direction = splitPresentationFilter[3]

        if (filterCategory === "myPresentations") {
            list = list.filter(x => ((x.modifiedBy !== null) ? x.modifiedBy.toLowerCase() : x.createdBy.toLowerCase()) === this.props.email.toLowerCase()).sort(dynamicSort("modifiedDate")).reverse()
        } else if (filterCategory === "templates") {
            list = list.filter(x => x.isTemplate === true).sort(dynamicSort("modifiedDate")).reverse()
        } else
            list = list.sort(dynamicSort("modifiedDate")).reverse()

        if (sortCategory === 'undefined') {
            sortCategory = "modifiedDate";
        }
        if (direction === 'undefined') {
            direction = "asc";
        }
        return (direction === "asc") ? list.sort(dynamicSort(sortCategory)) : list.sort(dynamicSort(sortCategory)).reverse()
    }

    getTagFilteredPresentationList = (unfilteredPresentationList) => {
        let filteredPresentations = [];
        let tagsFilterItems = this.props.presentationTagsFilter;

        for (var i in unfilteredPresentationList) {

            let currentPresentation = unfilteredPresentationList[i];

            //Check all the tags assigned the the presentation
            for (var j in currentPresentation.presentationTags) {

                let presentationTag = currentPresentation.presentationTags[j];

                //Check at least one matches the user-selected list of filters
                for (var k in tagsFilterItems) {

                    let tagFilter = tagsFilterItems[k];

                    //Add to filtered list if a match is found
                    if (presentationTag.tagID == tagFilter.id) {

                        //Avoid re-adding the same presentation to the filtered list
                        if (!filteredPresentations.includes(currentPresentation)) {
                            filteredPresentations.push(currentPresentation);
                            break;
                        }
                    }
                }
            }
        }
        return filteredPresentations;
    }

    render() {
        return (
            <>
                <div className="mainWrapper">
                    <div className="bodyPart">
                        <div className="contentWrapper">
                            <h2 className="pageHead">
                                <AssessmentIcon />
                                <span className="mainTitleBox">Presentation</span>
                                <div className="rightButton">
                                    {(this.props.role !== "Viewer") && <button className="btn" onClick={this.handleUploadPres} id="upload_btn">
                                        Upload New</button>}
                                </div>
                            </h2>
                            <div className="tabOutMain presentAtionOut">
                                <AppBar position="static">
                                    <div className="TabsData">
                                        <Tabs value={this.state.value} onChange={this.handleChangeForm}>
                                            <Tab label="MY PRESENTATIONS"  {...PresentationProps(0)} />
                                            <Tab label="ALL PRESENTATIONS" {...PresentationProps(1)} />
                                            <Tab label="Templates" {...PresentationProps(2)} />
                                        </Tabs>
                                        <TabPanel value={this.state.value} index={0}>
                                            <TableContainer component={Paper}>
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell onClick={this.handleSort}>Presentation Name {this.renderArrow("name")}</TableCell>
                                                            <TableCell align="right" onClick={this.handleSort}>Author{this.renderArrow("createdBy")}</TableCell>
                                                            <TableCell align="right" onClick={this.handleSort}>Last Edited{this.renderArrow("modifiedDate")}</TableCell>
                                                            <TableCell align="right">Actions</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                </Table>
                                                {this.props.custFolderList.map((folder) => {
                                                    return <Accordion key={`folder-${folder.id}`} expanded={this.state.expanded[folder.id] ? this.state.expanded[folder.id] : false} TransitionProps={{ unmountOnExit: true }} >
                                                        <AccordionSummary style={{ flexDirection: "row-reverse", paddingLeft: "3px" }}
                                                            expandIcon={this.state.expanded[folder.id] ? <FolderCloseIcon /> : <FolderOpenIcon />}
                                                            onClick={() => {
                                                                this.setExpanded(folder.id, !this.state.expanded[folder.id], );
                                                            }}
                                                        >
                                                            <Typography>&nbsp;{folder.folderName} ({this.presentationCount(folder.id)})</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails style={{ paddingLeft: "20px" }}>
                                                            <Table><TableHead><TableRow><TableCell /><TableCell /><TableCell /><TableCell /></TableRow></TableHead>
                                                                <TableBody>
                                                                    {this.renderPresentations(folder.id)}
                                                                </TableBody>
                                                            </Table>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                })
                                                }
                                                
                                                <Table><TableHead><TableRow style={{ height: "1px" }}><TableCell /><TableCell /><TableCell /><TableCell /></TableRow></TableHead>
                                                <TableBody>
                                                    {this.renderPresentations(null)}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </TabPanel>
                                        <TabPanel value={this.state.value} index={1}>
                                            <TableContainer component={Paper}>
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell onClick={this.handleSort}>Presentation Name {this.renderArrow("name")}</TableCell>
                                                            <TableCell align="right" onClick={this.handleSort}>Author{this.renderArrow("createdBy")}</TableCell>
                                                            <TableCell align="right" onClick={this.handleSort}>Last Edited{this.renderArrow("modifiedDate")}</TableCell>
                                                            <TableCell align="right">Actions</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                </Table>

                                                {this.props.custFolderList.map((folder) => {
                                                    return <Accordion key={`folder-${folder.id}`} expanded={this.state.expanded[folder.id] ? this.state.expanded[folder.id] : false} TransitionProps={{ unmountOnExit: true }} >
                                                        <AccordionSummary style={{ flexDirection: "row-reverse", paddingLeft: "3px" }}
                                                            expandIcon={this.state.expanded[folder.id] ? <FolderCloseIcon /> : <FolderOpenIcon />}
                                                            onClick={() => {
                                                                this.setExpanded(folder.id,!this.state.expanded[folder.id]);
                                                            }}
                                                        >
                                                            <Typography>&nbsp;{folder.folderName} ({this.presentationCount(folder.id)})</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails style={{ paddingLeft: "20px" }}>
                                                            <Table><TableHead><TableRow style={{ height: "1px" }}><TableCell /><TableCell /><TableCell /><TableCell /></TableRow></TableHead>
                                                                <TableBody>
                                                                    {this.renderPresentations(folder.id)}
                                                                </TableBody>
                                                            </Table>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                })
                                                }

                                                <Table><TableHead><TableRow style={{ height: "1px" }}><TableCell /><TableCell /><TableCell /><TableCell /></TableRow></TableHead>
                                                    <TableBody>
                                                        {this.renderPresentations(null)}
                                                    </TableBody>
                                                </Table>
                                            
                                                            
                                            </TableContainer>
                                        </TabPanel>
                                        <TabPanel value={this.state.value} index={2}>
                                            <TableContainer component={Paper}>
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell onClick={this.handleSort}>Presentation Name {this.renderArrow("name")}</TableCell>
                                                            <TableCell align="right" onClick={this.handleSort}>Author{this.renderArrow("createdBy")}</TableCell>
                                                            <TableCell align="right" onClick={this.handleSort}>Last Edited{this.renderArrow("modifiedDate")}</TableCell>
                                                            <TableCell align="right">Actions</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                </Table>
                                                {this.props.custFolderList.map((folder) => {
                                                    return <Accordion key={`folder-${folder.id}`} expanded={this.state.expanded[folder.id] ? this.state.expanded[folder.id] : false} TransitionProps={{ unmountOnExit: true }} >
                                                        <AccordionSummary style={{ flexDirection: "row-reverse", paddingLeft: "3px" }}
                                                            expandIcon={this.state.expanded[folder.id] ? <FolderCloseIcon /> : <FolderOpenIcon />}
                                                            onClick={() => {
                                                                this.setExpanded(folder.id,!this.state.expanded[folder.id]);
                                                            }}
                                                        >
                                                            <Typography>&nbsp;{folder.folderName} ({this.presentationCount(folder.id)})</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails style={{ paddingLeft: "20px" }}>
                                                            <Table><TableHead><TableRow style={{ height: "1px" }}><TableCell /><TableCell /><TableCell /><TableCell /></TableRow></TableHead>
                                                                <TableBody>
                                                                    {this.renderPresentations(folder.id)}
                                                                </TableBody>
                                                            </Table>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                })
                                                }
                                                   <Table><TableHead><TableRow style={{ height: "1px" }}><TableCell /><TableCell /><TableCell /><TableCell /></TableRow></TableHead>
                                                   <TableBody>
                                                        {this.renderPresentations(null)}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </TabPanel>
                                    </div>
                                </AppBar>
                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.uploadPres) ? <UploadPresentation uploadPresentation={this.props.uploadPresentation} showMessage={this.props.showMessage} /> : null}
                {(this.state.rightClick) ? <ContextMenu
                    id={this.state.id}
                    xPos={this.state.xPos}
                    yPos={this.state.yPos}
                    menuTemplate={["go to presentation", "rename presentation", "download presentation", "delete presentation"]}
                    goToPresentation={this.goToPresentation}
                    deletePresentation={this.contextDeletePresentation}
                    renamePresentation={this.renamePresentation}
                    downloadPresentation={this.contextDownloadPres}
                /> : null}
            </>
        )
    }

}

export default Presentations